import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import EntreprenorPage from './pages/EntreprenorPage';
import KloakservicePage from './pages/KloakservicePage';
import TvInspektionPage from './pages/TvInspektionPage';
import BetonarbejdePage from './pages/BetonarbejdePage';
import MaterialerPage from './pages/MaterialerPage';
import UdlejningPage from './pages/UdlejningPage';
import ProjectsPage from './pages/ProjectsPage';
import BygGarantiPage from './pages/BygGarantiPage';
import JobPage from './pages/JobPage';
import NewsProjectPage from './pages/NewsProjectPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-stone-100 text-stone-900 selection:bg-[#0072c0] selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* 1. Forside */}
            <Route path="/" element={<HomePage />} />
            
            {/* 2. Om os */}
            <Route path="/om-os" element={<AboutPage />} />

            {/* 3. Kontakt */}
            <Route path="/kontakt" element={<ContactPage />} />

            {/* 4. Entreprenør og anlæg */}
            <Route path="/entreprenerservice" element={<EntreprenorPage />} />
            <Route path="/entreprenor-og-anlaeg" element={<Navigate to="/entreprenerservice" replace />} />

            {/* 5. Kloak og klimasikring + undersider */}
            <Route path="/kloak-service" element={<KloakservicePage />} />
            <Route path="/rottespaerre" element={<KloakservicePage />} />
            <Route path="/klimatilpasning" element={<KloakservicePage />} />
            <Route path="/skybrud" element={<KloakservicePage />} />
            <Route path="/minirensningsanlaeg" element={<KloakservicePage />} />
            {/* Redirect /kloakspuling directly to /tv-inspektion per specification 20 */}
            <Route path="/kloakspuling" element={<Navigate to="/tv-inspektion" replace />} />

            {/* 6. TV-inspektion og kloakspuling */}
            <Route path="/tv-inspektion" element={<TvInspektionPage />} />

            {/* 7. Betonarbejde */}
            <Route path="/betonarbejde" element={<BetonarbejdePage />} />
            <Route path="/smk" element={<NewsProjectPage />} />
            <Route path="/kajkant" element={<Navigate to="/betonarbejde" replace />} />

            {/* 8. På pladsen / Salg af materialer og modtagelse af rene læs */}
            <Route path="/bygningsaffald" element={<MaterialerPage />} />
            <Route path="/materialer" element={<Navigate to="/bygningsaffald" replace />} />
            <Route path="/copy-of-salg-p%C3%A5-pladsen" element={<Navigate to="/bygningsaffald" replace />} />
            <Route path="/copy-of-salg-p-c3-a5-pladsen" element={<Navigate to="/bygningsaffald" replace />} />
            <Route path="/genbrugsstabil" element={<Navigate to="/bygningsaffald" replace />} />

            {/* 9. Udlejning */}
            <Route path="/udlejning" element={<UdlejningPage />} />

            {/* 10. Projektoversigt */}
            <Route path="/projekter" element={<ProjectsPage />} />

            {/* 11. Byg Garanti (bevaret teknisk) */}
            <Route path="/byg-garanti" element={<BygGarantiPage />} />

            {/* 12. Vi søger folk (bevaret på direkte URL, men skjult i nav) */}
            <Route path="/copy-of-kts-entreprise-a-s" element={<JobPage />} />
            <Route path="/job" element={<JobPage />} />

            {/* Fjernede projektsider viderestilles til projekter */}
            <Route path="/stormen-egon" element={<Navigate to="/projekter" replace />} />
            <Route path="/kloakprojekt-til-35-mio" element={<Navigate to="/projekter" replace />} />
            <Route path="/proppen-er-taget-af" element={<NewsProjectPage />} />
            <Route path="/ekstrem-situation" element={<NewsProjectPage />} />
            <Route path="/regionsmester-2013" element={<NewsProjectPage />} />
            <Route path="/nicklas-gr-efter-guldet" element={<NewsProjectPage />} />

            {/* Fejlsider */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
